export default function Footer() {
  return (
    <footer className="site-footer">
      <div>
        <div className="footer-brand">
          <img src="/logo.png" alt="raojatin.shop logo" loading="lazy" />
          <h4>raojatin.shop</h4>
        </div>
        <p>Single-product premium pixel gadget store.</p>
      </div>
      <div>
        <h4>Support</h4>
        <p>+91 9306018924</p>
        <p>WhatsApp: +91 9499473347</p>
        <p>info.raojatin@gmail.com</p>
      </div>
      <div>
        <h4>Shipping</h4>
        <p>Free shipping</p>
        <p>Delivery estimate: 20-25 days</p>
        <p>Prepaid only (No COD)</p>
      </div>
      <div className="footer-credit">
        <div className="footer-credit-inner">
          <p className="footer-credit-label">A website by</p>
          <a className="footer-credit-link" href="https://www.raojatin.in" target="_blank" rel="noreferrer">
            <span className="footer-credit-name">Rao Jatin</span>
            <span className="footer-credit-site">www.raojatin.in</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
